import React from "react";
import { DiagnosisModel } from "@common/models";
import { StringUtility } from "@common/utils";
import { isEmpty } from "lodash";

/**
 * Displays a message based on the current search state:
 * - When no query is entered → show "Start search" message.
 * - When query is entered but no results are found → show "No results" message.
 * - Otherwise → render nothing.
 */
export type IPetProfileSearchInitialDiagnosesDisclaimerProps = {
  query: string;
  filteredDiagnoses: DiagnosisModel[];
};

export const PetProfileSearchInitialDiagnosesDisclaimer = ({
  query,
  filteredDiagnoses,
}: IPetProfileSearchInitialDiagnosesDisclaimerProps) => {
  if (!StringUtility.hasValue(query)) {
    return (
      <div className="text-center text-muted py-3">
        Start search to see available diagnoses.
      </div>
    );
  }

  if (isEmpty(filteredDiagnoses)) {
    return (
      <div className="text-center text-muted py-3">
        No results found matching your filters.
      </div>
    );
  }

  return null; // Don't render when data exists
};
